TPS.PartnerSearch = {
    pnlSearch: null,
    pnlSearchForm: null,
    pnlSearchResults: null,
    pnlSelectedCompany: null,
    inputSelectedCompanyID: null,
    inputSelectedCompanyCode: null,
    inputSelectedCompanyName: null,
    inputSelectedCompanyRegistrationTypeID: null,
    btnBackToSearch: null,
    regActionWrapperClassName: 'registration-partner-company-selected-regaction',

    init: function () {
        TPS.PartnerSearch.pnlSearch = document.getElementById('pnlSearch');
        TPS.PartnerSearch.pnlSearchForm = document.getElementById('pnlSearchForm');
        TPS.PartnerSearch.pnlSearchResults = document.getElementById('pnlSearchResults');
        TPS.PartnerSearch.pnlSelectedCompany = document.getElementById('pnlSelectedCompany');
        TPS.PartnerSearch.inputSelectedCompanyID = document.getElementById('selectedCompanyID');
        TPS.PartnerSearch.inputSelectedCompanyCode = document.getElementById('selectedCompanyCode');
        TPS.PartnerSearch.inputSelectedCompanyName = document.getElementById('selectedCompanyName');
        TPS.PartnerSearch.inputSelectedCompanyRegistrationTypeID = document.getElementById('selectedCompanyRegistrationTypeID');
        TPS.PartnerSearch.btnBackToSearch = document.getElementById('btnBackToSearch');

        if (TPS.PartnerSearch.inputSelectedCompanyID) {
            TPS.PartnerSearch.inputSelectedCompanyID.addEventListener('change', TPS.PartnerSearch.handleCompanySelected);
        }

        if (TPS.PartnerSearch.btnBackToSearch) {
            TPS.PartnerSearch.btnBackToSearch.addEventListener('click', TPS.PartnerSearch.backToSearch);
        }

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Company');
    },

    handleCompanySelected: function (e) {
        var companyID = TPS.PartnerSearch.inputSelectedCompanyID.value;

        CMSApp.AV.API.Company.GetCompanyInfo(companyID, function (d) {
            if (d.length > 0) {
                TPS.PartnerSearch.inputSelectedCompanyCode.value = d[0].Code;
                TPS.PartnerSearch.inputSelectedCompanyName.value = d[0].Name;

                var companyName = document.getElementById('selectedCompanyTitle');
                var planName = document.getElementById('selectedCompanyPlanName');
                var administrator = document.getElementById('selectedCompanyPlanAdministrator');
                var address = document.getElementById('selectedCompanyAddress');

                var selectedCompanyAdministratorSection = document.getElementById('selectedCompanyAdministratorSection');
                var selectedCompanyAddressSection = document.getElementById('selectedCompanyAddressSection');

                companyName.innerHTML = d[0].Name;
                planName.innerHTML = d[0].ProgramName;

                if (d[0].CompanyKeyContact === "") {
                    selectedCompanyAdministratorSection.classList.add('hide');
                    selectedCompanyAddressSection.classList.add('end');
                } else {
                    selectedCompanyAdministratorSection.classList.remove('hide');
                    selectedCompanyAddressSection.classList.remove('end');
                    administrator.innerHTML = d[0].CompanyKeyContact;
                    if (d[0].CompanyKeyContactTitle !== "") {
                        administrator.innerHTML += '<br/>' + d[0].CompanyKeyContactTitle;
                    }
                    if (d[0].Phone !== "") {
                        administrator.innerHTML += '<br/><a href="tel:' + d[0].Phone + '" target="_blank">' + d[0].Phone + '</a>';
                    }
                    if (d[0].CompanyKeyContactEmail !== "") {
                        administrator.innerHTML += '<br/><a href="mailto:' + d[0].CompanyKeyContactEmail + '" target="_blank">' + d[0].CompanyKeyContactEmail + '</a>';
                    }
                }

                var addressText = '';
                if (d[0].Address !== "") {
                    addressText += d[0].Address;
                }
                if (d[0].City !== "") {
                    addressText += '<br/>' + d[0].City;
                    if (d[0].StateDisplayName !== "") {
                        addressText += ', ' + d[0].StateDisplayName;
                    }
                }
                if (d[0].Zipcode !== "") {
                    addressText += '<br/>' + d[0].Zipcode;
                    if (d[0].CountryTwoLetterCode !== "") {
                        addressText += ' ' + d[0].CountryTwoLetterCode;
                    }
                }
                if (addressText === "") {
                    selectedCompanyAddressSection.classList.add('hide');
                } else {
                    selectedCompanyAddressSection.classList.remove('hide');
                    address.innerHTML = addressText;
                }

                TPS.PartnerSearch.pnlSearchForm.classList.add('hide');
                TPS.PartnerSearch.pnlSearchResults.classList.add('hide');
                TPS.PartnerSearch.pnlSelectedCompany.classList.remove('hide');
                TPS.PartnerSearch.hideRegActionWrappers();

                var regType = TPS.PartnerSearch.inputSelectedCompanyRegistrationTypeID.value;
                var targetRegActionWrapper = document.querySelector('.' + TPS.PartnerSearch.regActionWrapperClassName + '[data-registration-type="' + regType + '"]');

                if (regType === "2") {
                    var idmebutton = document.getElementById('idme-wallet-button');

                    if (idmebutton) {
                        window.BindIDme(); // manually init ID.me because this section was hidden
                    }
                }
                // populate the link to the basic registration button
                if (regType === "4" || regType === "2") {

                    if (targetRegActionWrapper) {
                        var link = targetRegActionWrapper.querySelector('.registration-partner-company-selected-regaction-basic-registration');
                        link.href = '/register/?partner=' + TPS.PartnerSearch.inputSelectedCompanyCode.value;
                    }
                }

                if (targetRegActionWrapper) {
                    targetRegActionWrapper.classList.remove('hide');
                }
            }

        }, function (d) { console.log(d); alert('Error while getting the company info'); });
    },

    backToSearch: function () {
        TPS.PartnerSearch.inputSelectedCompanyID.value = '';
        TPS.PartnerSearch.inputSelectedCompanyCode.value = '';
        TPS.PartnerSearch.inputSelectedCompanyName.value = '';
        TPS.PartnerSearch.inputSelectedCompanyRegistrationTypeID.value = '';

        TPS.PartnerSearch.pnlSearchForm.classList.remove('hide');
        TPS.PartnerSearch.pnlSearchResults.classList.remove('hide');
        TPS.PartnerSearch.pnlSelectedCompany.classList.add('hide');

        TPS.PartnerSearch.hideRegActionWrappers();
    },

    hideRegActionWrappers: function () {
        var regActionWrappers = document.querySelectorAll('.' + TPS.PartnerSearch.regActionWrapperClassName);

        for (var i = 0; i < regActionWrappers.length; i++) {
            regActionWrappers[i].classList.add('hide');
        }
    }
}
